import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios-cad-nx';
import {
    ApiResultSearchUnitHistoryResponse,
    ElasticCobaltSortKeyEnum,
    UnitHistoryResource,
} from '@mark43/cad-api';
import { useApiClient } from '@m43/core';
import { MAX_UNIT_HISTORY_RESULTS } from '../constants';
import { useSetSearchUnitHistoryResponse } from '../context/hooks';
import { UnitHistoryForm } from '../types';
import { unitHistoryFormToElasticUserActionQuery } from '../unit-history-form-to-elastic-user-action-query';

export function useUnitHistorySearchMutation(): UseMutationResult<
    AxiosResponse<ApiResultSearchUnitHistoryResponse, any>,
    unknown,
    UnitHistoryForm,
    unknown
> {
    const setSearchUnitHistoryResponse = useSetSearchUnitHistoryResponse();
    const apiClient = useApiClient();
    return useMutation(
        (unitHistoryForm: UnitHistoryForm) => {
            return apiClient.request<UnitHistoryResource.SearchUnitHistory>({
                method: 'POST',
                url: 'unit_history',
                data: {
                    elasticQuery: unitHistoryFormToElasticUserActionQuery(unitHistoryForm),
                    size: MAX_UNIT_HISTORY_RESULTS,
                    sorts: [
                        {
                            sortKey: ElasticCobaltSortKeyEnum.USER_ACTION_CREATED_DATE_UTC.name,
                            sortType: unitHistoryForm.sortTypeOption.value,
                        },
                    ],
                    // fields to make TS happy
                    sourceExcludeFilter: [],
                    sourceIncludeFilter: [],
                },
            });
        },
        {
            onSuccess(data) {
                setSearchUnitHistoryResponse(data.data.data);
            },
        }
    );
}
